import Utils from './Utils.js';
import Common from './Common.js';
import WinResize from './WinResize.js';
import Swipe from './SwipeHelper.js';
import Article from './Article.js';
import SubNavi from './SubNavigation.js';

class Section {
    constructor(_el, _idx){
        this.container = $(_el);
        this.idx = _idx;
        this.scrHCon = this.container.find('.scr-h');

        this.comm = Common.instance;
        this.winRe = WinResize.instance;

        this.newArticle = null;
        this.oldArticle = null;
    }

    init() {

        this.articleList = [];
        let articles = this.scrHCon.find( '> article');
        let articleLength = articles.length;
        articles.each( (idx, el)=>{
            const articleItem = new Article(el, articleLength);
            this.articleList.push( articleItem );
        });

        this.scrHCon.css({ width: articles.length*100 + '%'});

        if(this.comm.option.motionStyle=='cover'){
            let yPos = this.comm.mainContainer[0].clientHeight;
            if(this.idx == 1) yPos = 0;
            let cssObj = {};
                cssObj['transition-duration'] = '0ms';
                cssObj[Utils.vPrefix + 'transform'] = `translate(0px, ${yPos}px)`;
                cssObj['transform'] = `translate(0px, ${yPos}px)`;

            this.container.css(cssObj);
        }

        this.winRe.addCallback( () => this.winResize() );
        new Swipe({container: this.scrHCon, direction: 'horizontal', dragEl: this.scrHCon});
        this.subNavi = new SubNavi(this.container, this.articleList, this.comm.option.useSubNavi);

        this.winResize();
    }

    winResize(){
        this.container.css({
            height: this.comm.mainContainer[0].clientHeight
        });
    }

    get articleLength(){
        return this.articleList.length;
    }

    anchorStr(_d1, _d2){
        return this.articleList[_d2-1].anchor;
    }

    showIn(_depth){
        const xPos = -(100 / this.articleList.length * (_depth.d2-1));

        let cssObj = {};
            cssObj['transition-duration'] = this.comm.option.transitionDuration + 'ms';
            cssObj[Utils.vPrefix + 'transform'] = `translate(${xPos}%, 0px)`;
            cssObj['transform'] = `translate(${xPos}%, 0px)`;

        this.scrHCon.css(cssObj);

        this.container.toggleClass('active', true);

        this.newArticle = this.articleList[_depth.d2-1];
        this.newArticle.showIn();

        this.subNavi.setActive(_depth.d2);

        if(this.oldArticle && this.oldArticle !== this.newArticle) this.oldArticle.showOut();
        this.oldArticle = this.newArticle;
    }

    showOut(){
        if(this.oldArticle){
            this.oldArticle.showOut();
            this.oldArticle = null;
        }
        this.container.toggleClass('active', false);
    }

    showInCover(_depth){
        let yPos = 0;

        if(_depth.d1<this.idx){
            yPos = this.comm.mainContainer[0].clientHeight;
        }
        if(_depth.d1>this.idx){
            yPos = -200;
        }

        let cssObj = {};
            cssObj['transition-duration'] = this.comm.option.transitionDuration + 'ms';
            cssObj[Utils.vPrefix + 'transform'] =`translate(0px, ${yPos}px)`;
            cssObj['transform'] =`translate(0px, ${yPos}px)`;

        this.container.css(cssObj);
    }


}

export default Section;


// WEBPACK FOOTER //
// ./Section.js